import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'

export default {
    baseInputMixin: {
        data() {
            return {
                focus: false,
                localValue: "",
                showHelpText: true,
            }
        },
        inject: ['$validator'],
        computed: {
            ...mapGetters([
                'getField'
            ]),
            uniqueName() {
                return this.store + "__" + this.name;
            },
            value: {
                get() {
                    return !this.store.length ? this.localValue : this.getField({
                        'store': this.store,
                        'key': this.name
                    });
                },
                set(value) {
                    if (this.store.length) {
                        this.updateField({
                            'store': this.store,
                            'key': this.name,
                            'value': value,
                        })
                    } else {
                        this.localValue = value;
                    }
                }
            },

        },
        methods: {
            ...mapActions([
                'updateField'
            ]),
        },
        props: {
            name: {type: String, default: ""},
            store: {type: String, default: ""},
            type: {type: String, default: ""},
            placeholder: {type: String, default: ""},
            label: {type: String, default: ""},
            fieldClass: {type: String, default: ""},
            visible: {type: [Boolean, Function], default: true},
            max: {type: String, default: ""},
            validation: {type: String, default: ""},
            validationErrorMessage: {type: String, default: ""},
            displayFilter: {type: String, default: ""},
            inputMask: {type: String, default: ""},
            legend: {type: String, default: ""},
            disabled: {type: Boolean, default: false},
            helpText: {type: String, default: ""},
            onInput: Function,
            attrs: {
                type: Object, default: function () {
                    return {};
                }
            }
        }
    },

    baseClassMethodsMixin: {
        methods: {
            genericFieldClass: function (elementname) {

                var baseClasses = [
                    //    elementname,
                    'eda__' + elementname,
                    //      'field-' + this.type + '__' + elementname,
                    //      this.type + '__' + elementname
                ];

                /* split up classes in case there are multiple */
                if (this.fieldClass.length) {
                    var fieldClasses = this.fieldClass.split(" ");
                    var type = this.type;
                    fieldClasses.forEach(function (val) {
                        baseClasses.push(val + '__' + elementname);
                        //        baseClasses.push(val + '-' + type + '__' + elementname);
                    });
                }
                return this.modify(baseClasses);

            },

            modify: function (baseClasses) {

                var stateClasses = [];

                this.focus && baseClasses.forEach(function (val) {
                    stateClasses.push(val + "--active");
                });

                this.disabled && baseClasses.forEach(function (val) {
                    stateClasses.push(val + "--disabled");
                });

                !(this.value === undefined) && this.value.length && baseClasses.forEach(function (val) {
                    stateClasses.push(val + "--filled");
                });

                (!this.focus && this.errors.has(this.uniqueName)) && baseClasses.forEach(function (val) {
                    stateClasses.push(val + "--validation-error");
                });

                var classes = baseClasses.concat(stateClasses);
                classes.push("field-" + this.name);

                return classes.join(' ');

            },

            mainClass: function () {

                var baseClasses = ["foa-field" /* "field-" + this.type */];

                if (!this.visible) {
                    baseClasses.push("hidden");
                }

                /* split up classes in case there are multiple */
                if (this.fieldClass.length) {
                    var fieldClasses = this.fieldClass.split(" ");
                    var type = this.type;
                    fieldClasses.forEach(function (val) {
                        baseClasses.push(val);
                        baseClasses.push("field-" + val);
                    });
                }

                return this.modify(baseClasses);


            },

            inputClass: function () {
                return this.genericFieldClass("input");
            },
            labelClass: function () {
                return this.genericFieldClass("label");
            },


        }
    }
}

